import type { MouseEvent } from 'react';
import cx from 'clsx';
import { web2app } from '@kcd/app-interface';
import { useToast } from '@kcd/design-system';

import type { ProductOptionDetail } from '~/api/model';

import Counter from '~/components/Counter';

import { CloseIcon } from '~/assets/icons';

type Props = {
  option: ProductOptionDetail;
  onChange: (count: number) => void;
  onDelete?: () => void;
  className?: string;
};

export function SelectedProductOption({
  option,
  onChange,
  onDelete,
  className,
}: Props) {
  const toast = useToast();

  return (
    <div
      className={cx([
        'flex gap-12 items-center justify-between pb-12 pt-8 border-b-gray-200 border-b-[1px]',
        className,
      ])}
    >
      <div className="overflow-hidden">
        <p className="break-all typo-paragraph100-regular">{option.name}</p>
        {!option.isDefault && (
          <strong className="mt-2 text-hint typo-caption100-regular">
            {option.priceDifferenceText}
          </strong>
        )}
      </div>
      <div className="flex items-center gap-12 ">
        <Counter
          initialValue={option.calcMinimumOrderQuantity}
          gap={option.orderPerMultipleQuantity}
          min={option.calcMinimumOrderQuantity}
          max={option.orderableQuantity}
          onChange={onChange}
          onFail={toast}
        />
        {onDelete && (
          <CloseIcon
            className={cx('flex-shrink-0 w-16 h-16', className)}
            onClick={(event: MouseEvent) => {
              event.stopPropagation();
              void web2app
                .openDialogAsync({
                  type: 'destructive',
                  description: '상품을 삭제하시겠습니까?',
                })
                .then(({ confirmed }) => {
                  if (!confirmed) {
                    return;
                  }

                  onDelete?.();
                  toast('상품이 삭제되었습니다');
                });
            }}
          />
        )}
      </div>
    </div>
  );
}
